import { render, staticRenderFns } from "./AccountConfigRuntime.vue?vue&type=template&id=10d67803"
import script from "./AccountConfigRuntime.vue?vue&type=script&lang=js"
export * from "./AccountConfigRuntime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports